import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ChainsComponent } from './chains.component';
import { ChainsEditComponent } from './chains.edit.component';
import { ChainsCreateComponent } from './chains.create.component';
import { ChainService } from './chain.service';

@NgModule({
  declarations: [ChainsComponent, ChainsEditComponent, ChainsCreateComponent],
  imports: [HttpClientModule, CommonModule, ReactiveFormsModule, NgbModule],
  providers: [ChainService],
  entryComponents: [ChainsComponent, ChainsEditComponent, ChainsCreateComponent],
})
export class ChainsModule {}



// WEBPACK FOOTER //
// ./src/app/chains/chains.module.ts